import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import homeService from "../../../services/HomeService";
import searchRequestService from "../../../services/SearchService";
import { getRandomArbitrary } from "./../../Global/tools.js";

import NanoFlex from "./../../Global/NanoFlex.js";
import Loading from "./../../Nano/Loading.js";
import InsightsBlock from "./../../Micro/InsightsBlock.js";
import MainCarrosel from "../../Micro/MainCarrossel";
import Grid from "../../Macro/Grid.js";
import WrapperList from "./../../Nano/WrapperList.js";
import ViewMore from "./../../Nano/ViewMore.js";
import TitleCard from "./../../Nano/TitleCard.js";

// const t0 = performance.now();

const multiple = nota.global.multiple;
const maxCards = nota.global.cardsMaxLength;
const functionsStack = ["getNotaSelectionPrograms", "getNotaInsights", "getSavedSearchPrograms", "getAudienceBoosterPrograms", "getUpCommingPrograms", "getLatestPrograms"];

const emptyObj = () => {
  const randomId = getRandomArbitrary(1000000, 9999999);
  return {
    idProgram: randomId,
    channel: null,
    country: null,
    date: null,
    image: null,
    localTitle: null,
    performanceColor: null,
  };
};

const addEmptyCardIfNeeded = (list) => {
  if (list.length >= maxCards) return list;

  let outputList = new Array(maxCards).fill(null);
  outputList = outputList.map((v, i) => {
    if (list[i]) {
      return list[i];
    } else {
      return emptyObj();
    }
  });

  return outputList;
};

const allEmptyCards = addEmptyCardIfNeeded([]);

const StyledHome = styled.div`
  width: 100%;
  padding: ${multiple * 2 + "px"}; /* 16px */

  .mainHome {
    display: ${(props) => (props.shouldShow ? "initial" : "none")};
  }

  .mainHomeContent {
    visibility: ${(props) => (props.shouldShow ? "visible" : "hidden")};
  }

  .notaSelectionWrapper {
    .grid {
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    }
  }

  .clickableWrapper {
    cursor: pointer;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1496px) {
    .doubleContainer {
      .grid {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      }
    }
    .audienceBoosterWrapper {
      .grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      }
    }
  }
  @media only screen and (max-width: 800px) {
    .doubleContainer {
      flex-direction: column;
      .grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      }
    }
    .titleWrapper {
      .primaryTitleWrapper {
        margin-top: 8px;
      }
    }
  }
`;

const StyledLoading = styled(NanoFlex)`
  height: calc(100vh - 130px);
`;

export class Home extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      isLoading: this.loadingArray(functionsStack.length),
      shouldShow: false,
      notaSelectionPrograms: null,
      insights: null,
      savedSearchPrograms: null,
      audienceBooster: null,
      upCommingPrograms: null,
      latestPrograms: null,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onHomeLanguageChange, false);

    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isLoading !== this.state.isLoading && this.isLoadingDoneAllOutput(this.state.isLoading)) {
      this.toggleShouldShow();
    }

    if (!this.state.shouldShow && prevState.shouldShow !== this.state.shouldShow && this.isLoadingDoneAllOutput(this.state.isLoading)) {
      this.toggleShouldShow();
    }

    if (prevState.shouldShow !== this.state.shouldShow) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 200);
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onHomeLanguageChange, false);
  }

  onHomeLanguageChange = () => {
    this.setState(this.getDefaultState(), () => {
      this.getAllData();
    });
  };

  loadingArray = (servicesNumber) => {
    return new Array(servicesNumber).fill(true);
  };

  toggleShouldShow = () => {
    if (!this.state.shouldShow) this.setState({ shouldShow: true });
  };

  getAllData = () => {
    functionsStack.forEach((name) => this[name]());
  };

  getNotaSelectionPrograms = () => {
    homeService
      .getNotaSelectionPrograms()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        let newIsLoading = [...this.state.isLoading];
        newIsLoading[functionsStack.indexOf("getNotaSelectionPrograms")] = false;
        this.setState({ isLoading: newIsLoading, notaSelectionPrograms: data });
      });
  };

  getNotaInsights = () => {
    homeService
      .getNotaInsights()
      .then((response) => {
        if (response.ok) {
          return response.status !== 204 ? response.json() : null;
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        let newIsLoading = [...this.state.isLoading];
        newIsLoading[functionsStack.indexOf("getNotaInsights")] = false;
        this.setState({ isLoading: newIsLoading, notaInsights: data });
      });
  };

  getSavedSearchPrograms = () => {
    searchRequestService
      .getSavedSearchPrograms()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        let newIsLoading = [...this.state.isLoading];
        newIsLoading[functionsStack.indexOf("getSavedSearchPrograms")] = false;
        this.setState({ isLoading: newIsLoading, savedSearchPrograms: data });
      });
  };

  getAudienceBoosterPrograms = () => {
    homeService
      .getAudienceBoosterPrograms()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        let newIsLoading = [...this.state.isLoading];
        newIsLoading[functionsStack.indexOf("getAudienceBoosterPrograms")] = false;
        this.setState({ isLoading: newIsLoading, audienceBooster: data });
      });
  };

  getUpCommingPrograms = () => {
    homeService
      .getUpCommingPrograms()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((value) => {
        let newIsLoading = [...this.state.isLoading];
        newIsLoading[functionsStack.indexOf("getUpCommingPrograms")] = false;
        this.setState({ isLoading: newIsLoading, upCommingPrograms: value });
      });
  };

  getLatestPrograms = () => {
    homeService
      .getLatestPrograms()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((value) => {
        let newIsLoading = [...this.state.isLoading];
        newIsLoading[functionsStack.indexOf("getLatestPrograms")] = false;
        this.setState({ isLoading: newIsLoading, latestPrograms: value });
      });
  };

  addEmptyCardIfNeeded = (list) => {
    if (list.length >= maxCards) return list;

    let outputList = new Array(maxCards).fill(null);
    outputList = outputList.map((v, i) => {
      if (list[i]) {
        return list[i];
      } else {
        return emptyObj();
      }
    });

    return outputList;
  };

  isLoadingDoneAllOutput = (list) => {
    return list.every((bool) => bool === false);
  };

  render() {
    const isLoadingDoneAll = this.isLoadingDoneAllOutput(this.state.isLoading);
    const { notaSelectionPrograms, notaInsights, savedSearchPrograms, audienceBooster, latestPrograms, upCommingPrograms } = this.state;

    return (
      <StyledHome shouldShow={this.state.shouldShow}>
        {!isLoadingDoneAll && (
          <StyledLoading className="loadingContainer">
            <Loading />
          </StyledLoading>
        )}
        <div className="mainHome">
          <NanoFlex flexDirection="column" className="mainHomeContent">
            {
              notaSelectionPrograms &&
                notaSelectionPrograms.length > 0 /*? (
              !this._isMobile ? (
                <MainCarrosel data={notaSelectionPrograms} isLoadingDone={isLoadingDoneAll} cardsLength={12} indicator={false} />
              ) :`*/ && (
                  <NanoFlex className="notaSelectionWrapper">
                    <WrapperList>
                      <div
                        className="clickableWrapper"
                        onClick={() => {
                          window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "NotaSelection" } }));
                        }}>
                        <ViewMore />
                        <TitleCard title={this.translation.home.vip.title} secTitle={this.translation.home.vip.secTitle} />
                      </div>
                      <Grid data={notaSelectionPrograms} row={1} isCarrosel={true} />
                    </WrapperList>
                  </NanoFlex>
                )
              /*) : null*/
            }

            {notaInsights && (
              <NanoFlex>
                <InsightsBlock data={notaInsights} />
              </NanoFlex>
            )}
            {audienceBooster && audienceBooster.length > 0 && (
              <NanoFlex className="audienceBoosterWrapper">
                <WrapperList background>
                  <div
                    className="clickableWrapper"
                    onClick={() => {
                      window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "AudienceBooster" } }));
                    }}>
                    <ViewMore />
                    <TitleCard title={this.translation.home.audienceBooster.title} secTitle={this.translation.home.audienceBooster.subTitle} />
                  </div>
                  <Grid data={audienceBooster} row={1} isCarrosel={true} />
                </WrapperList>
              </NanoFlex>
            )}
            {savedSearchPrograms && savedSearchPrograms.savedSearch1 && savedSearchPrograms.savedSearch1.programs.length > 0 && (
              <NanoFlex className="doubleContainer" flexDirection="row" justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex>
                  <WrapperList>
                    <div
                      className="clickableWrapper"
                      onClick={() => {
                        window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { id: savedSearchPrograms.savedSearch1.id, menu: "SavedSearch", lastCall: savedSearchPrograms.savedSearch1.lastCall, filter: savedSearchPrograms.savedSearch1.filter } }));
                      }}>
                      <ViewMore />
                      <TitleCard title={savedSearchPrograms ? savedSearchPrograms.savedSearch1.searchName.toUpperCase() : ""} />
                    </div>
                    <Grid data={savedSearchPrograms.savedSearch1.programs} row={this._isMobile || (savedSearchPrograms.savedSearch1?.programs?.length ?? 0) <= 3 || (savedSearchPrograms.savedSearch2?.programs?.length ?? 0) <= 3 ? 1 : 2} isCarrosel={true} />
                  </WrapperList>
                </NanoFlex>
                {savedSearchPrograms && savedSearchPrograms.savedSearch2 && savedSearchPrograms.savedSearch2.programs.length > 0 && (
                  <NanoFlex>
                    <WrapperList>
                      <div
                        className="clickableWrapper"
                        onClick={() => {
                          window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { id: savedSearchPrograms.savedSearch2.id, menu: "SavedSearch", lastCall: savedSearchPrograms.savedSearch2.lastCall, filter: savedSearchPrograms.savedSearch2.filter } }));
                        }}>
                        <ViewMore />
                        <TitleCard title={savedSearchPrograms ? savedSearchPrograms.savedSearch2.searchName.toUpperCase() : ""} />
                      </div>
                      <Grid data={savedSearchPrograms.savedSearch2.programs} row={this._isMobile || (savedSearchPrograms.savedSearch1?.programs?.length ?? 0) <= 3 || (savedSearchPrograms.savedSearch2?.programs?.length ?? 0) <= 3 ? 1 : 2} isCarrosel={true} />
                    </WrapperList>
                  </NanoFlex>
                )}
              </NanoFlex>
            )}
            {((latestPrograms && latestPrograms.length > 0) || (upCommingPrograms && upCommingPrograms.length > 0)) && (
              <NanoFlex className="doubleContainer" flexDirection="row" justifyContent={"flex-start"} alignItems={"flex-start"}>
                {latestPrograms && latestPrograms.length > 0 && (
                  <NanoFlex>
                    <WrapperList>
                      <div
                        className="clickableWrapper"
                        onClick={() => {
                          window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Latest" } }));
                        }}>
                        <ViewMore />
                        <TitleCard title={this.translation.home.latest.title} />
                      </div>
                      <Grid data={latestPrograms} row={this._isMobile || (latestPrograms?.length ?? 0) <= 3 || (upCommingPrograms?.length ?? 0) <= 3 ? 1 : 2} isCarrosel={true} />
                    </WrapperList>
                  </NanoFlex>
                )}
                {upCommingPrograms && upCommingPrograms.length > 0 && (
                  <NanoFlex>
                    <WrapperList>
                      <div
                        className="clickableWrapper"
                        onClick={() => {
                          window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Upcoming" } }));
                        }}>
                        <ViewMore />
                        <TitleCard title={this.translation.home.upcoming.title} />
                      </div>
                      <Grid data={upCommingPrograms} row={this._isMobile || (latestPrograms?.length ?? 0) <= 3 || (upCommingPrograms?.length ?? 0) <= 3 ? 1 : 2} isCarrosel={true} />
                    </WrapperList>
                  </NanoFlex>
                )}
              </NanoFlex>
            )}
          </NanoFlex>
        </div>
      </StyledHome>
    );
  }
}
